import { render, staticRenderFns } from "./tags_menu.vue?vue&type=template&id=28ed3c61"
import script from "./tags_menu.vue?vue&type=script&lang=js"
export * from "./tags_menu.vue?vue&type=script&lang=js"
import style0 from "./tags_menu.vue?vue&type=style&index=0&id=28ed3c61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports